const data = {
  books: [
    {
      id: "1",
      bkName: "eloquent javascript",
      price: 30,
      image: "https://m.media-amazon.com/images/I/91asIC1fRwL.jpg",
    },
    {
      id: "2",
      bkName: "javascript the good parts",
      price: 22,
      image: "https://m.media-amazon.com/images/I/81kqrwS1nNL.jpg",
    },
    {
      id: "3",
      bkName: "javascript and jquery interactive front end web development",
      price: 35,
      image:
        "https://m.media-amazon.com/images/S/aplus-media-library-service-media/00cf3832-5dca-4401-84eb-44abd2c793f1.__CR0,0,1500,1500_PT0_SX300_V1___.jpg",
    },
    {
      id: "4",
      bkName: "You Don't Know JS: Scope & Closures",
      price: 20,
      image: "https://m.media-amazon.com/images/I/41ultdqyvXL._AC_SY780_.jpg",
    },
    {
      id: "5",
      bkName: "Learn JavaScript Visually: With Interactive Exercisest",
      price: 30,
      image:
        "https://i.gr-assets.com/images/S/compressed.photo.goodreads.com/books/1404619084i/22668194._UY423_SS423_.jpg",
    },
    {
      id: "6",
      bkName: "The Principles of Object-Oriented JavaScript",
      price: 40,
      image: "https://m.media-amazon.com/images/I/518hypqfQVL._AC_SY780_.jpg",
    },
  ],
};

export default data;
